module.exports = __webpack_public_path__ + "media/images/flags/4x3/vct-1474ccf5a8807db4d5ece2b9d743955e.svg";